import React from "react";
import { useSelector } from "react-redux";
import { getTab } from "../../../../shared/utils/tabsUtils";
import Widget from "../../../../shared/components/features/widget/Widget";
import financialEducationImg from "../../../../assests/financialEducation/financialEducation.png";
import classes from "./FinancialEducationWidget.module.css";

const FinancialEducationWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#FFF"
            width={250}
            height={250}
            mainLink={getTab("financialEducation")?.route}
            className={classes.FinancialEducationWidget}
            titleColor="#0F2B4F"
            contentScrollable={false}
        >
            <div className={classes.WidgetContent}>
                <img
                    src={financialEducationImg}
                    alt={texts.financialEducation}
                    className={classes.FinancialEducationImg}
                />
            </div>
        </Widget>
    );
};

export default FinancialEducationWidget;